export enum TreeSearchEvent {
  START_FETCHING = 'searchTreeStartFetching',
  INPUT_RESET = 'searchTreeResetToEmpty',
  ITEM_CLICKED = 'searchTreeItemClicked',
}
